import { faDice, faListUl } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EvaluationSubmission from 'models/EvaluationSubmission';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'view/components/buttons/Button';
import Modal from 'view/components/common/Modal';
import { IMAGES } from 'assets/images';
import { EVALUATION_DISPLAY_NAMES } from 'utils/types';

type EvaluationPreviewPopupProps = {
  evaluationPreview?: EvaluationSubmission;
  isOpen: boolean;
  onClose: () => void;
};

const EvaluationPreviewPopup: React.FC<EvaluationPreviewPopupProps> = ({
  evaluationPreview,
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="user-alert-popup">
        <div className="row">
          <img src={IMAGES.characters.wormy_student} alt="Orator" />
          <div className="col user-alert-detail">
            <h3>
              {EVALUATION_DISPLAY_NAMES[evaluationPreview?.type ?? 'wida']}{' '}
              Evaluation
            </h3>
            <div className="assignment-detail">
              <FontAwesomeIcon icon={faDice} />
              <label className="label-normal">
                Rounds: {evaluationPreview?.rounds}
              </label>
              <hr />
            </div>
            <div className="assignment-detail">
              <FontAwesomeIcon icon={faListUl} />
              <label className="label-normal">
                Questions per round: {evaluationPreview?.questions_per_round}
              </label>
              <hr />
            </div>
            <i>Make sure you are somewhere quiet where you can focus.</i>
            <Button
              type="go"
              label="Begin!"
              text="Begin"
              onClick={() => navigate(`evaluation/${evaluationPreview?.id}`)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EvaluationPreviewPopup;
